import { createLucideIcon } from "lucide-react";

export const Add = createLucideIcon(
    "Add",
    [
        [
            "path",
            {
                d: "M12 4V20",
                key: "88rgac",
            },
        ],
        [
            "path",
            {
                d: "M4 12H20",
                key: "h7dt9m",
            },
        ],
    ],
);
